import React, {Component, forwardRef, useImperativeHandle} from 'react';
import {SnackbarProvider, useSnackbar} from 'notistack';
import {jssPreset, StylesProvider} from '@material-ui/core/styles';
import {create} from "jss";
import {
    DeleteAssignedGroup,
    DeleteOrder,
    DeleteUser,
    NewAssignedGroup,
    NewOrder,
    NewUser,
    subscribe,
    UpdateAssignedGroup,
    UpdateOrder,
    UpdateUser
} from "../../Events/topics";
import {getMessage} from "./SnackbarMessages";
import {shallowEqualObjects} from "shallow-equal";

const SnackBarPrivate = forwardRef((props, ref) => {
    const {enqueueSnackbar} = useSnackbar();

    useImperativeHandle(ref, () => ({
        showSnackbar(text) {
            enqueueSnackbar(text);
        }
    }));

    return (
        <React.Fragment/>
    );
});

const jss = create({plugins: [...jssPreset().plugins]});

export default class SnackBar extends Component {
    constructor(props) {
        super(props);

        this.child = React.createRef();

        this.subscribeToEnabledNotifications(props.notifications);
    }

    subscribeToEnabledNotifications(notifications) {
        if (notifications.newOrder) this.newOrderSubscription = this.subscribeToTopic(NewOrder);
        if (notifications.deleteOrder) this.deleteOrderSubscription = this.subscribeToTopic(DeleteOrder);
        if (notifications.updateOrder) this.updateOrderSubscription = this.subscribeToTopic(UpdateOrder);

        if (notifications.newUser) this.newUserSubscription = this.subscribeToTopic(NewUser);
        if (notifications.deleteUser) this.deleteUserSubscription = this.subscribeToTopic(DeleteUser);
        if (notifications.updateUser) this.updateUserSubscription = this.subscribeToTopic(UpdateUser);

        if (notifications.newAssignedGroup) this.newAssignedGroupSubscription = this.subscribeToTopic(NewAssignedGroup);
        if (notifications.deleteAssignedGroup) this.deleteAssignedGroupSubscription = this.subscribeToTopic(DeleteAssignedGroup);
        if (notifications.updateAssignedGroup) this.updateAssignedGroupSubscription = this.subscribeToTopic(UpdateAssignedGroup);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (!shallowEqualObjects(this.props.notifications, nextProps.notifications)) {
            this.unsubscribeAllNotifications();
            this.subscribeToEnabledNotifications(nextProps.notifications);
        }
    }

    componentWillUnmount() {
        this.unsubscribeAllNotifications();
    }

    subscribeToTopic(topic) {
        return subscribe(topic, this.onNewMessage.bind(this))
    }

    unsubscribeAllNotifications() {
        if (this.newOrderSubscription) {
            this.newOrderSubscription.unsubscribe();
            this.newOrderSubscription = null;
        }

        if (this.deleteOrderSubscription) {
            this.deleteOrderSubscription.unsubscribe();
            this.deleteOrderSubscription = null;
        }

        if (this.updateOrderSubscription) {
            this.updateOrderSubscription.unsubscribe();
            this.updateOrderSubscription = null;
        }

        if (this.newUserSubscription) {
            this.newUserSubscription.unsubscribe();
            this.newUserSubscription = null;
        }

        if (this.deleteUserSubscription) {
            this.deleteUserSubscription.unsubscribe();
            this.deleteUserSubscription = null;
        }

        if (this.updateUserSubscription) {
            this.updateUserSubscription.unsubscribe();
            this.updateUserSubscription = null;
        }

        if (this.newAssignedGroupSubscription) {
            this.newAssignedGroupSubscription.unsubscribe();
            this.newAssignedGroupSubscription = null;
        }

        if (this.deleteAssignedGroupSubscription) {
            this.deleteAssignedGroupSubscription.unsubscribe();
            this.deleteAssignedGroupSubscription = null;
        }

        if (this.updateAssignedGroupSubscription) {
            this.updateAssignedGroupSubscription.unsubscribe();
            this.updateAssignedGroupSubscription = null;
        }
    }


    onNewMessage(message) {
        const allData = {
            orders: this.props.orders,
            messengers: this.props.messengers
        };

        const snackBarMessage = getMessage(message, allData);

        if (snackBarMessage)
            this.child.current.showSnackbar(snackBarMessage);
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return false;
    }

    render() {
        return (
            <StylesProvider jss={jss}>
                <SnackbarProvider maxSnack={3} autoHideDuration={20000}>
                    <SnackBarPrivate ref={this.child}/>
                </SnackbarProvider>
            </StylesProvider>
        );
    }
}